import OpcoesTributarias from "../shared/OpcoesTributarias.js";

export default class Nfse {
    constructor() {
        this.dados = {
            id: "",
            numero: "",
            status: 0,
            tomador: { id: "", content: "" },
            servico: { id: "", content: "" },
            locacao: { id: "", content: "" },
            emails: [],
            json: "",
            descricao: "",
            mensagemErro: "",
            urlReceita: "",
            urlPdf: "",
            urlXml: "",
            valorImposto: 0,
            valorNota: 0,
            valorFinal: 0,
        }

        this.regimeTributario = {
            codigoOpcaoSimplesNacional: { id: "", content: "" },
            tipoTributacao: { id: "", content: "" },
            regimeEspecialTributacaoMunicipal: { id: "", content: "" },
            regimeApuracaoTributariaSimplesNacional: { id: "", content: "" },
            situacaoTributariaPisCofins: { id: "", content: "" },
        }

        this.imposto = {
            issRetido: false,
            issAliquota: 0,
            issValor: 0,
            pisCofinsRetido: false,
            pisAliquota: 0,
            pisValor: 0,
            cofinsAliquota: 0,
            cofinsValor: 0,
            csllAliquota: 0,
            csllValor: 0,
            irAliquota: 0,
            irValor: 0,
            ibsAliquota: 0,
            cbsAliquota: 0,
        }

        this.transparencia = {
            percentualTotalTributosFederais: 0,
            valorTotalTributosFederais: 0,
            percentualTotalTributosEstaduais: 0,
            valorTotalTributosEstaduais: 0,
            percentualTotalTributosMunicipais: 0,
            valorTotalTributosMunicipais: 0,
        }

        this.localEvento = {
            codigoEvento: "",
            nomeEvento: "",
            dataInicioEvento: "",
            dataFimEvento: "",
            cepEvento: "",
            logradouroEvento: "",
            numeroEvento: "",
            complementoEvento: "",
            bairroEvento: "",
        };
    }

    update(data) {
        this.id = data.id;

    }

    static createObj(nfseNacional, ehSimplesNacional) {
        const dados = nfseNacional.dados;
        const regime = nfseNacional.regimeTributario;
        const imposto = nfseNacional.imposto;
        const transparencia = nfseNacional.transparencia;
        const localEvento = nfseNacional.localEvento;
        const dataInicioEvento = Array.isArray(localEvento.dataInicioEvento) && localEvento.dataInicioEvento.length === 0
            ? ""
            : localEvento.dataInicioEvento;
        const dataFimEvento = Array.isArray(localEvento.dataFimEvento) && localEvento.dataFimEvento.length === 0
            ? ""
            : localEvento.dataFimEvento;

        return {
            id: dados.id,
            numero: dados.numero,
            status: dados.status,
            simplesNacional: ehSimplesNacional,
            emails: dados.emails,

            tomador: dados.tomador,
            servico: dados.servico,
            locacao: dados.locacao,

            descricao: dados.descricao,
            mensagemErro: dados.mensagemErro,

            valorImposto: dados.valorImposto,
            valorNota: dados.valorNota,
            valorFinal: dados.valorFinal,

            codigoOpcaoSimplesNacional: regime.codigoOpcaoSimplesNacional,
            tipoTributacao: regime.tipoTributacao,
            regimeEspecialTributacaoMunicipal: regime.regimeEspecialTributacaoMunicipal,
            regimeApuracaoTributariaSimplesNacional: regime.regimeApuracaoTributariaSimplesNacional,
            situacaoTributariaPisCofins: regime.situacaoTributariaPisCofins,

            issRetido: imposto.issRetido,
            issAliquota: imposto.issAliquota,
            issValor: imposto.issValor,

            pisCofinsRetido: imposto.pisCofinsRetido,
            pisAliquota: imposto.pisAliquota,
            pisValor: imposto.pisValor,

            cofinsAliquota: imposto.cofinsAliquota,
            cofinsValor: imposto.cofinsValor,

            csllAliquota: imposto.csllAliquota,
            csllValor: imposto.csllValor,

            irAliquota: imposto.irAliquota,
            irValor: imposto.irValor,

            ibsAliquota: imposto.ibsAliquota,
            cbsAliquota: imposto.cbsAliquota,

            percentualTotalTributosFederais: transparencia.percentualTotalTributosFederais,
            valorTotalTributosFederais: transparencia.valorTotalTributosFederais,

            percentualTotalTributosEstaduais: transparencia.percentualTotalTributosEstaduais,
            valorTotalTributosEstaduais: transparencia.valorTotalTributosEstaduais,

            percentualTotalTributosMunicipais: transparencia.percentualTotalTributosMunicipais,
            valorTotalTributosMunicipais: transparencia.valorTotalTributosMunicipais,

            codigoEvento: localEvento.codigoEvento,
            nomeEvento: localEvento.nomeEvento,
            dataInicioEvento: dataInicioEvento,
            dataFimEvento: dataFimEvento,

            cepEvento: localEvento.cepEvento,
            logradouroEvento: localEvento.logradouroEvento,
            numeroEvento: localEvento.numeroEvento,
            complementoEvento: localEvento.complementoEvento,
            bairroEvento: localEvento.bairroEvento,
        };
    }

    static updateObj(nfseNacional, data) {
        nfseNacional.dados.id = data.dados.id;
        nfseNacional.dados.status = data.dados.status;
        nfseNacional.dados.mensagemErro = data.dados.mensagemErro;
        nfseNacional.dados.valorNota = data.dados.valorNota;
        nfseNacional.dados.valorImposto = data.dados.valorImposto;
        nfseNacional.dados.valorFinal = data.dados.valorFinal;

        nfseNacional.dados.numero = data.dados.numero;
        nfseNacional.dados.tomador = data.dados.tomador;
        nfseNacional.dados.servico = data.dados.servico;
        nfseNacional.dados.locacao = data.dados.locacao;
        nfseNacional.dados.descricao = data.dados.descricao;
        nfseNacional.dados.urlReceita = data.dados.urlReceita;
        nfseNacional.dados.urlPdf = data.dados.urlPdf;
        nfseNacional.dados.urlXml = data.dados.urlXml;
        nfseNacional.dados.json = data.dados.json;

        nfseNacional.regimeTributario.codigoOpcaoSimplesNacional = OpcoesTributarias.codigoOpcaoSimplesNacional.find(x => x.id == data.regimeTributario.codigoOpcaoSimplesNacional.id);
        nfseNacional.regimeTributario.tipoTributacao = OpcoesTributarias.tipoTributacao.find(x => x.id == data.regimeTributario.tipoTributacao.id);
        nfseNacional.regimeTributario.regimeApuracaoTributariaSimplesNacional = OpcoesTributarias.regimeApuracaoTributariaSimplesNacional.find(x => x.id == data.regimeTributario.regimeApuracaoTributariaSimplesNacional.id);
        nfseNacional.regimeTributario.regimeEspecialTributacaoMunicipal = OpcoesTributarias.regimeEspecialTributacaoMunicipal.find(x => x.id == data.regimeTributario.regimeEspecialTributacaoMunicipal.id);
        nfseNacional.regimeTributario.situacaoTributariaPisCofins = OpcoesTributarias.situacaoTributariaPisCofins.find(x => x.id == data.regimeTributario.situacaoTributariaPisCofins.id);

        nfseNacional.imposto.issRetido = data.imposto.issRetido;
        nfseNacional.imposto.issAliquota = data.imposto.issAliquota;
        nfseNacional.imposto.issValor = data.imposto.issValor;
        nfseNacional.imposto.pisCofinsRetido = data.imposto.pisCofinsRetido;
        nfseNacional.imposto.pisAliquota = data.imposto.pisAliquota;
        nfseNacional.imposto.pisValor = data.imposto.pisValor;
        nfseNacional.imposto.cofinsAliquota = data.imposto.cofinsAliquota;
        nfseNacional.imposto.cofinsValor = data.imposto.cofinsValor;
        nfseNacional.imposto.csllAliquota = data.imposto.csllAliquota;
        nfseNacional.imposto.csllValor = data.imposto.csllValor;
        nfseNacional.imposto.irAliquota = data.imposto.irAliquota;
        nfseNacional.imposto.irValor = data.imposto.irValor;
        nfseNacional.imposto.ibsAliquota = data.imposto.ibsAliquota;
        nfseNacional.imposto.cbsAliquota = data.imposto.cbsAliquota;

        nfseNacional.transparencia.percentualTotalTributosFederais = data.transparencia.percentualTotalTributosFederais;
        nfseNacional.transparencia.valorTotalTributosFederais = data.transparencia.valorTotalTributosFederais;
        nfseNacional.transparencia.percentualTotalTributosEstaduais = data.transparencia.percentualTotalTributosEstaduais;
        nfseNacional.transparencia.valorTotalTributosEstaduais = data.transparencia.valorTotalTributosEstaduais;
        nfseNacional.transparencia.percentualTotalTributosMunicipais = data.transparencia.percentualTotalTributosMunicipais;
        nfseNacional.transparencia.valorTotalTributosMunicipais = data.transparencia.valorTotalTributosMunicipais;

        nfseNacional.localEvento.codigoEvento = data.localEvento.codigoEvento;
        nfseNacional.localEvento.nomeEvento = data.localEvento.nomeEvento;
        nfseNacional.localEvento.dataInicioEvento = data.localEvento.dataInicioEvento;
        nfseNacional.localEvento.dataFimEvento = data.localEvento.dataFimEvento;
        nfseNacional.localEvento.cepEvento = data.localEvento.cepEvento;
        nfseNacional.localEvento.logradouroEvento = data.localEvento.logradouroEvento;
        nfseNacional.localEvento.numeroEvento = data.localEvento.numeroEvento;
        nfseNacional.localEvento.complementoEvento = data.localEvento.complementoEvento;
        nfseNacional.localEvento.bairroEvento = data.localEvento.bairroEvento;
    }
}
